module.exports = __webpack_public_path__ + "img/19_60.36e5ffa3.png";